const DEFAULT_AUTH_ERROR_MESSAGE = 'An error occurred. Please try again later.';

const AUTH_ERROR_MESSAGES: Record<string, string> = {
  'auth/user-not-found': 'User not found. Please double-check your email.',
  'auth/wrong-password': 'Incorrect password. Please try again.',
  'auth/invalid-credential': 'Incorrect email or password. Please try again.',
  'auth/invalid-login-credentials':
    'Incorrect email or password. Please try again.',
  'auth/invalid-email': 'Please enter a valid email address.',
  'auth/email-already-in-use':
    'This email is already registered. Please use a different email or try logging in.',
  'auth/weak-password': 'Password should be at least 6 characters long.',
  'auth/network-request-failed':
    'Network error. Please check your internet connection and try again.',
  'auth/too-many-requests':
    'Too many unsuccessful login attempts. Please try again later.',
  'auth/user-disabled':
    'This account has been disabled. Please contact support.',
  'auth/operation-not-allowed':
    'This operation is not allowed. Please contact support.',
  'auth/account-exists-with-different-credential':
    'An account already exists with the same email but different sign-in credentials. Please clear your cookies and log in with the existing credentials.',
  'auth/requires-recent-login':
    'This operation requires a more recent login. Please log out and log in again.',
  'auth/popup-closed-by-user': 'Login popup was closed. Please try again.',
  'auth/cancelled-popup-request': 'Login popup was closed. Please try again.',
  'auth/popup-blocked':
    'Your browser blocked the sign-in popup. Please allow popups for this site and try again.',
  'auth/web-storage-unsupported':
    'Your browser is blocking third-party storage needed for sign-in. Disable "Prevent Cross-Site Tracking" in your browser settings, or try a different browser.',
  'auth/operation-not-supported-in-this-environment':
    "Sign-in isn't supported in this browser. Please try a different browser.",
};

export function getReadableAuthErrorMessage(errorOrCode: any): string {
  const code =
    typeof errorOrCode === 'string' ? errorOrCode : errorOrCode?.code;
  return AUTH_ERROR_MESSAGES[code] || DEFAULT_AUTH_ERROR_MESSAGE;
}
